import api from "../services/api";
import { notifyError } from "./notifications";

async function getDefaultInvoicePdf(
  invoiceId: number,
  due_date: string,
  cpf: string
) {
  // Possui try catch porque em caso de erro devemos buscar a fatura de contingência
  try {
    const data = await api.get(
      "billet_pdf",
      { invoice_id: invoiceId, raw_pdf: "true", due_date, cpf },
      { "Content-Type": "application/pdf" },
      true
    );

    return data;
  } catch (error) {
    console.error(`Error in getDefaultInvoicePdf ${error}`);
    return undefined;
  }
}

async function getContingencyInvoicePdf({
  invoiceId,
  clientId,
}: {
  invoiceId: number;
  clientId: number;
}) {
  // Por ser "último" caso, em caso de erro, devemos repassar o erro
  return api.get(
    "contingency_invoice",
    { invoiceId, raw_pdf: "true", clientId },
    { "Content-Type": "application/pdf" },
    true
  );
}

export async function getInvoicePdf({
  invoiceId,
  initLoadingState,
  finishLoadingState,
  clientId,
  due_date,
  cpf,
  handleShowPopUpModal,
}: {
  invoiceId: number;
  initLoadingState: () => void;
  finishLoadingState: () => void;
  clientId: number;
  due_date: string;
  cpf: string;
  handleShowPopUpModal: () => void;
}) {
  try {
    initLoadingState();
    let invoicePdf;
    // Busca pdf da fatura na API da Horizon
    invoicePdf = await getDefaultInvoicePdf(invoiceId, due_date, cpf);

    // Em caso de erro no primeiro passo, gera a fatura de contingência
    if (!invoicePdf) {
      invoicePdf = await getContingencyInvoicePdf({ invoiceId, clientId });
    }

    const fileURL = URL.createObjectURL(await invoicePdf.blob());
    const pdfWindow = window.open(fileURL);
    if (
      !pdfWindow ||
      pdfWindow.closed ||
      typeof pdfWindow.closed === "undefined"
    ) {
      return handleShowPopUpModal();
    }
    setTimeout(() => {
      if (pdfWindow) {
        pdfWindow.document.title = "Fatura.pdf";
      }
    }, 750);
  } catch (error: any) {
    const stringError: string = error?.message ?? "";

    if (stringError.includes("detail")) {
      const splitArray = stringError.split("detail:");
      const detailText = splitArray[1].split(",")[0].trim();
      return detailText
        ? notifyError(detailText)
        : notifyError("Falha ao buscar PDF da fatura");
    }
    const splitArray = stringError.split(",");
    const basicError = splitArray[0].trim();
    return basicError
      ? notifyError(basicError)
      : notifyError("Falha ao buscar PDF da fatura");
  } finally {
    finishLoadingState();
  }
}
